import { render, staticRenderFns } from "./noConnection.vue?vue&type=template&id=98f27ea2&scoped=true&"
import script from "./noConnection.vue?vue&type=script&lang=js&"
export * from "./noConnection.vue?vue&type=script&lang=js&"
import style0 from "@/css/styleModules.css?vue&type=style&index=0&id=98f27ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f27ea2",
  null
  
)

export default component.exports